import React, { useRef, useState } from 'react';
import { Button, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import api from '../services/api';
import { getApiErrorMessage } from '../utils/apiError';

interface AttemptsExcelExportButtonProps {
  userSearch?: string;
  department?: string;
  testId?: number;
  dateFrom?: string;
  dateTo?: string;
}

export default function AttemptsExcelExportButton({ userSearch = '', department, testId, dateFrom, dateTo }: AttemptsExcelExportButtonProps) {
  const [loading, setLoading] = useState(false);
  const busy = useRef(false);
  const hasFilters = Boolean(userSearch.trim() || dateFrom || dateTo) || department !== undefined || testId !== undefined;

  const download = async () => {
    if (busy.current) return;
    busy.current = true;
    setLoading(true);
    let url: string | undefined;
    let anchor: HTMLAnchorElement | undefined;
    try {
      const response = await api.get('/admin/attempts/export-excel', {
        responseType: 'blob',
        ...(hasFilters ? { params: {
          ...(userSearch.trim() ? { user_search: userSearch.trim() } : {}),
          ...(department !== undefined ? { department } : {}),
          ...(testId !== undefined ? { test_id: testId } : {}),
          ...(dateFrom ? { date_from: dateFrom } : {}),
          ...(dateTo ? { date_to: dateTo } : {}),
        } } : {}),
      });
      url = URL.createObjectURL(response.data);
      anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = /filename="([A-Za-z0-9_.-]+\.xlsx)"/.exec(
        response.headers['content-disposition'] || '',
      )?.[1] || 'test_attempts.xlsx';
      document.body.appendChild(anchor);
      anchor.click();
    } catch (error: any) {
      let exportError = error;
      if (error?.response?.data instanceof Blob) {
        try {
          exportError = { ...error, response: { ...error.response, data: JSON.parse(await error.response.data.text()) } };
        } catch { /* Use the normal download error if the response is not JSON. */ }
      }
      message.error(getApiErrorMessage(exportError, 'Не удалось выгрузить попытки в Excel'));
    } finally {
      anchor?.remove();
      if (url) URL.revokeObjectURL(url);
      busy.current = false;
      setLoading(false);
    }
  };

  return <Button icon={<DownloadOutlined />} loading={loading} onClick={download}
    title={hasFilters
      ? 'Скачать попытки по выбранным фильтрам со всех страниц'
      : 'Скачать все попытки, включая остальные страницы таблицы'}>Выгрузить в Excel</Button>;
}
